import { rydeColors, rydeColorsGraphs } from "@ryde/theme";

/** Clustered/stacked bar-chart config, grouped so members are accessed as `MultiSeriesChartConstants.x`. */
export const MultiSeriesChartConstants = {
  /** Series colors: brand purple, then progressively lighter purples. */
  seriesColors: [
    rydeColorsGraphs.verticalBarDefaultColor,
    rydeColors.brightVividPurple,
    rydeColors.iridescentPurple,
    rydeColors.neonBoneyard,
  ],
  maxBarThickness: 48,
  stackId: "total",
  /** Category-axis ticks run smaller here since clustered/stacked charts pack more bars. */
  categoryTickFontSize: 10,
} as const;
